import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { Layout } from '../components/layout';
import { Home, ArrowLeft, Recycle } from 'lucide-react';
import { useSafeAnimation, useCanAnimate } from '../components/ui/SafeMotion';

export function NotFound() {
  const anim = useSafeAnimation({ opacity: 0, y: 20 }, { opacity: 1, y: 0 });
  const canAnimate = useCanAnimate();

  return (
    <Layout>
      <Helmet>
        <title>Page Not Found - Punarvaa</title>
      </Helmet>

      <section className="min-h-[80vh] flex items-center justify-center bg-gradient-to-b from-p-50 to-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={anim.initial}
            animate={anim.animate}
            className="max-w-lg mx-auto text-center"
          >
            {canAnimate ? (
              <motion.div
                animate={{ rotate: [0, 360] }}
                transition={{ duration: 20, repeat: Infinity, ease: 'linear' }}
                className="w-32 h-32 bg-p-100 rounded-full flex items-center justify-center mx-auto mb-8"
              >
                <Recycle className="w-16 h-16 text-p-600" />
              </motion.div>
            ) : (
              <div className="w-32 h-32 bg-p-100 rounded-full flex items-center justify-center mx-auto mb-8">
                <Recycle className="w-16 h-16 text-p-600" />
              </div>
            )}

            <h1 className="text-8xl font-bold font-display text-p-200 mb-4">404</h1>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">Page Not Found</h2>

            <p className="text-muted-foreground mb-8">
              Looks like this page has been recovered. Let us get you back on track.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link
                to="/"
                className="px-6 py-3 bg-gradient-to-r from-p-600 to-p-700 text-white font-medium rounded-xl hover:from-p-700 hover:to-p-800 transition-all flex items-center justify-center gap-2"
              >
                <Home className="w-5 h-5" />
                Go Home
              </Link>
              <button
                onClick={() => window.history.back()}
                className="px-6 py-3 border border-p-200 text-p-700 font-medium rounded-xl hover:bg-p-50 transition-colors flex items-center justify-center gap-2"
              >
                <ArrowLeft className="w-5 h-5" />
                Go Back
              </button>
            </div>
          </motion.div>
        </div>
      </section>
    </Layout>
  );
}
